export default __webpack_public_path__ + "static/media/pro-elevate-gry-banner-1.2a8e7ef4.jpg";